import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "flex flex-col items-center py-10 w-full" }
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-3 md:gap-4 mt-10 w-full px-4 text-center md:w-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: "plex-regular flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "object-contain w-11/12 md:w-8/12 lg:w-4/12 py-6 md:py-0 mb-5",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "px-5 py-2 border border-[#2e8842] bg-[#2e8842] text-xl text-white font-semibold hover:bg-green-900 hover:border-[#2e8842] rounded-2xl"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "pi pi-user mr-2" }, null, -1),
              _createTextVNode("ACREDITARME ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/credenciales",
            class: "px-5 py-2 border border-[#2e8842] bg-[#2e8842] text-xl text-white font-semibold hover:bg-green-900 hover:border-[#2e8842] rounded-2xl"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "pi pi-qrcode mr-2" }, null, -1),
              _createTextVNode("YA ME ACREDITÉ ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ], 4),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-1 bg-[#207893]" }, null, -1))
  ], 64))
}